module.exports = __webpack_public_path__ + "img/vieraslaituri_original.184d88fc.jpg";